export class AmountRangeClass {    
    public min?: number;
    public max?: number;
    public includeNulls:boolean = false;
}